<ng-content select="mulo-facets-active"></ng-content>

<!-- <ng-container select="mulo-facet-section"></ng-container> -->
<ng-content select="mulo-facet-sort"></ng-content>

<ng-content select="mulo-facet-section"></ng-content>

